import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpRepo } from '@shared/services/httprepo';
import { ApiEndPointType } from '@shared/enums/common';
import { AuthService } from '@services/auth.service';
import { CommonMethods } from '@services/common.method';

@Injectable({
    providedIn: 'root'
})
export class SaItemService {

    constructor(private auth: AuthService, private httpRepo: HttpRepo, private commonMethod: CommonMethods) {
        httpRepo.setAbsoluteUrl(this.auth.getCompanyId(), ApiEndPointType.FS);
    }

    public SaveSaItem(data: any): Observable<any> {
        data.ID = CommonMethods.GetID();
        return this.httpRepo.Post("pricebook/serviceagreementitems", data);
    }
    public SaveEditSaItem(data: any): Observable<any> {
        return this.httpRepo.Put("pricebook/serviceagreementitems/" + data.ID, data);
    }
    public GetSaItem(ID: any): Observable<any> {
        return this.httpRepo.Get("pricebook/serviceagreementitems/" + ID + "?references=*");
    }
    public UploadDocument() {
        return this.httpRepo.AbsoluteURL + "/pricebook/serviceagreementitemsattachment";
    }
    public EditUploadDocument(formData) {
        return this.httpRepo.PostFile("pricebook/serviceagreementitemsattachment", formData); 
    }
    public UploadExternalDocument(val: string) {
        return this.httpRepo.Post("pricebook/externalserviceagreementitemsattachment", val);
    } 
}
